/* autogenerated */
export interface ConnectionOutput {
  name: string
  imgId?: string
  privacy?: string
  terms?: string
  deletion: AppDeletion
}

export interface AppDeletion {
  type?: AppDeletionType
  url?: string
  name?: string
  email?: string
  address?: string
}

export enum AppDeletionType {
  API_CALLBACK = 'api-callback',
  INSTRUCTIONS = 'instructions',
}

export interface GetAppOutput {
  name: string
  imgId?: string
  status: AppStatus
  partnerId: string
  partnerName: string
  partnerImgId?: string
  environment: TokeetEnvironment
}

export enum AppStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DELETED = 'deleted',
}

export enum TokeetEnvironment {
  STAGE = 'stage',
  PROD = 'prod',
}

export interface AppIdInput {
  _id: string
}

export interface CreateAppInput {
  partnerId: string
  name: string
  redirectUrls: string[]
  webhookUrl?: string
  privacy?: string
  terms?: string
  deletion?: AppDeletionInput
  security?: AppSecurityInput
  imgId?: string
}

export interface AppDeletionInput {
  type?: string
  url?: string
  name?: string
  email?: string
  address?: string
}

export interface AppSecurityInput {
  serverIp?: string[]
  settingsIp?: string[]
  email?: string
}

export interface UpdateAppInput {
  _id: string
  name?: string
  redirectUrls?: string[]
  webhookUrl?: string
  privacy?: string
  terms?: string
  deletion?: AppDeletionInput
  security?: AppSecurityInput
  imgId?: string
}

export interface TestAppWebhookInput {
  _id: string
  webhookUrl?: string
  scope?: string
  event?: string
  pkey?: string
  account?: number
}

export interface SuccessOutput {
  success: boolean
}

export interface LoginInput {
  email: string
  password: string
}

export interface LoginOutput<T extends Partial<UserGql> = UserGql> {
  token?: string
  user?: T
}

export interface UserGql {
  _id: string
  firstname: string
  lastname: string
  email: string
  status: string
  imgId?: string
  createdAt: number
  role?: string
}

export interface SignupInput {
  firstname: string
  lastname: string
  email: string
  company: string
  password: string
  imgId?: string
}

export interface UpdateMeInput {
  firstname?: string
  lastname?: string
  email?: string
  password?: string
  imgId?: string
}

export interface UpdatePartnerInput {
  _id: string
  company?: string
  imgId?: string
}

export interface CheckInput {
  email: string
}

export interface CheckOutput {
  exists: boolean
}

export interface ForgotPasswordInput {
  email: string
}

export interface ResetPasswordInput {
  token: string
  newPassword?: string
}

export interface EventGql {
  _id: string
  type: string
  account: number
  hostname: string
  method?: string
  url?: string
  ip?: string
  scope?: string
  appId?: string
  partnerId: string
  userId?: string
  payload: string | JSON
  response?: JSON
  status: string
  startedAt: number
  completedMs: number
  completedAt: number
  createdAt: number
}

export interface EventsPageGql<T extends EventGql = EventGql> {
  total: number
  data: T[]
}

export interface AppGql {
  _id: string
  partnerId: string
  secret: string
  name: string
  redirectUrls: string[]
  webhookUrl?: string
  status: string
  environment: string
  privacy?: string
  terms?: string
  imgId?: string
  deletion: AppDeletionGql
  security: AppSecurityGql
  scopes: ScopesGql
  grants: AppGrantsGql
  createdAt: number
  createdBy: string
  readmeUrl: string
}

export interface AppDeletionGql {
  type?: string
  url?: string
  name?: string
  email?: string
  address?: string
}

export interface AppSecurityGql {
  serverIp?: string[]
  settingsIp?: string[]
  email?: string
}

export interface ScopesGql {
  bookingfees: boolean
  bookingcosts: boolean
  calendars: boolean
  channelAdjustments: boolean
  charges: boolean
  checkins: boolean
  customCodes: boolean
  dataFeeds: boolean
  expenses: boolean
  extras: boolean
  groupRates: boolean
  images: boolean
  incidents: boolean
  invoices: boolean
  messages: boolean
  messagesEmail: boolean
  preferences: boolean
  rates: boolean
  rentals: boolean
  rentalsAccess: boolean
  rentalsCreate: boolean
  reviews: boolean
  rooms: boolean
  shares: boolean
  tags: boolean
  tasks: boolean
  templates: boolean
  triggers: boolean
  guestsCreate: boolean
  guests: boolean
  inquiries: boolean
  inventories: boolean
  inquiriesCreate: boolean
  inquiriesCancel: boolean
  users: boolean
  discounts: boolean
  bookingformulas: boolean
  smartdevices: boolean
}

export interface AppGrantsGql {
  authorizationCode: boolean
  implicit: boolean
  refreshToken: boolean
}

export interface PartnerGql {
  _id: string
  company: string
  status: string
  imgId?: string
  scopes: ScopesGql
  createdAt: number
  role?: RoleType
  userId?: string
}

export enum RoleType {
  OWNER = 'owner',
  DEV = 'dev',
  QA = 'qa',
}

export interface AccountAppGql {
  account: number
  appId: string
  partnerId: string
  createdAt: number
  environment: string
  name: string
  email: string
  country: string
  rentalsAmount: number
}

export interface DisconnectAccountInput {
  appId: string
  account: number
}

export interface AccountAppPageGql {
  total: number
  data: AccountAppGql[]
}

export interface EventsFiltersArg {
  methods?: string[]
  statuses?: string[]
  scopes?: string[]
  createdAt?: TimestampsRange
  accounts?: number[]
}

export interface TimestampsRange {
  from: number
  to: number
}

export interface ListAppsDto {
  limit?: number
  skip?: number
  sort?: number
  sortBy?: ListAppsSort
  search?: string
}

export enum ListAppsSort {
  CREATED_AT = 'createdAt',
}

export interface ListAppOutput {
  id: string
  name?: string
  environment?: TokeetEnvironment
  connectedAt: number
  scopes?: ScopesModel
  deletion: AppDeletionPick
}

export interface ScopesModel {
  bookingcosts: boolean
  bookingfees: boolean
  calendars: boolean
  channelAdjustments: boolean
  charges: boolean
  checkins: boolean
  customCodes: boolean
  dataFeeds: boolean
  expenses: boolean
  extras: boolean
  groupRates: boolean
  images: boolean
  incidents: boolean
  invoices: boolean
  inventories: boolean
  messages: boolean
  messagesEmail: boolean
  preferences: boolean
  rates: boolean
  rentals: boolean
  rentalsAccess: boolean
  rentalsCreate: boolean
  reviews: boolean
  rooms: boolean
  shares: boolean
  tags: boolean
  tasks: boolean
  templates: boolean
  triggers: boolean
  guests: boolean
  guestsCreate: boolean
  inquiries: boolean
  inquiriesCreate: boolean
  inquiriesCancel: boolean
  users: boolean
  discounts: boolean
  bookingformulas: boolean
  smartdevices: boolean
}

export interface AppDeletionPick {
  type?: AppDeletionType
  url?: string
}
